import { selectorFamily } from 'recoil';
import Employee from 'src/interfaces/api/Employee';
import employeesState from '../atoms/employees';

const employeeState = selectorFamily<undefined | Employee, undefined | Employee['id']>({
  key: 'employee',
  get: (id) => ({ get }) => {
    if (!id) {
      return undefined;
    }
    const employees = get(employeesState);
    return employees[id];
  },
  set: (id) => ({ set }, newEmployee) => {
    if (id) {
      set(employeesState, (prevState) => ({ ...prevState, [id]: newEmployee as Employee }));
    }
  },
});

export { employeeState };
